import React, { useEffect, useState } from "react";
import { Camera, RotateCw, ShoppingBag } from "lucide-react";
import api from "../../lib/api";

const FACE = "/lifestyle/lifestyle_hero.png";

export default function AppTryOn() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState(0);
  const [scanning, setScanning] = useState(false);

  useEffect(() => {
    api.get("/products").then(r => setProducts((r.data || []).filter(p => !p.is_legacy)));
    setScanning(true);
    const t = setTimeout(() => setScanning(false), 1800);
    return () => clearTimeout(t);
  }, []);

  const selected = products[active];

  return (
    <div data-testid="app-tryon" className="pb-6">
      <header className="px-5 pt-12 pb-3">
        <div className="text-[11px] tracking-luxury uppercase text-poche-gold">Virtual Try-On</div>
        <div className="text-[10px] text-white/55 tracking-wider">Simulated camera preview · Pose your face on the dot.</div>
      </header>

      <div className="relative mx-4 aspect-[3/4] bg-poche-ink overflow-hidden">
        <img src={FACE} alt="" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="tryon-frame" />
        {scanning && (
          <div className="absolute inset-x-0 top-0 h-1 bg-poche-gold shimmer-gold" />
        )}
        <div className="absolute top-2 left-2 right-2 flex items-center justify-between text-[9px] tracking-luxury uppercase text-poche-gold">
          <span>● Live</span>
          <span>POCHE TRY-ON · 1.4</span>
        </div>
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2">
          <button className="bg-white/85 w-10 h-10 flex items-center justify-center"><RotateCw size={14} stroke="#0A0A0A" /></button>
          <button className="bg-poche-gold w-12 h-12 flex items-center justify-center"><Camera size={16} stroke="#0A0A0A" /></button>
        </div>
      </div>

      {/* Frame picker */}
      <div className="px-5 mt-5">
        <div className="text-[10px] tracking-luxury uppercase text-white/45 mb-2">Choose a frame</div>
        <div className="flex gap-2 overflow-x-auto no-scrollbar">
          {products.map((p, i) => (
            <button key={p.product_id} data-testid={`tryon-pick-${p.product_id}`} onClick={() => setActive(i)} className={`flex-shrink-0 w-20 ${i === active ? "ring-1 ring-poche-gold" : ""}`}>
              <div className="bg-poche-ivory aspect-square overflow-hidden">
                <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />
              </div>
              <div className="text-[9px] tracking-luxury uppercase text-white/65 mt-1 truncate">{p.subtitle}</div>
            </button>
          ))}
        </div>
        {selected && (
          <div className="mt-5 bg-poche-ink border border-poche-gold/30 p-4 flex items-center justify-between">
            <div>
              <div className="font-serif text-lg">{selected.subtitle}</div>
              <div className="text-poche-gold text-sm">${selected.price.toLocaleString()}</div>
            </div>
            <button data-testid="tryon-buy" className="bg-poche-gold text-poche-black text-[10px] tracking-luxury uppercase px-4 py-2 flex items-center gap-2">
              <ShoppingBag size={12} /> Buy
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
